import React, { useState, useEffect } from 'react';
import { Save, Key, Clock, FileText } from 'lucide-react';
import * as api from '../services/api';

function Settings() {
  const [loading, setLoading] = useState(false);
  const [passwordForm, setPasswordForm] = useState({
    current_password: '',
    new_password: '',
    confirm_password: ''
  });
  const [logs, setLogs] = useState('');

  const handlePasswordChange = async (e) => {
    e.preventDefault();

    if (passwordForm.new_password !== passwordForm.confirm_password) {
      alert('New passwords do not match');
      return;
    }

    try {
      await api.changeAdminPassword(passwordForm);
      alert('Password changed successfully');
      setPasswordForm({
        current_password: '',
        new_password: '',
        confirm_password: ''
      });
    } catch (error) {
      alert('Failed to change password: ' + (error.response?.data?.error || error.message));
    }
  };

  const loadLogs = async () => {
    setLoading(true);
    try {
      const response = await api.getSystemLogs();
      setLogs(response.data.logs || 'No logs available');
    } catch (error) {
      setLogs('Failed to load logs: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="page-header">
        <h2>System Settings</h2>
        <p>Configure system preferences and view logs</p>
      </div>

      {/* Change Admin Password */}
      <div className="table-container" style={{ marginBottom: '20px' }}>
        <div className="table-header">
          <h3>
            <Key size={20} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
            Change Admin Password
          </h3>
        </div>
        <div style={{ padding: '20px' }}>
          <form onSubmit={handlePasswordChange} style={{ maxWidth: '500px' }}>
            <div className="form-group">
              <label>Current Password</label>
              <input
                type="password"
                value={passwordForm.current_password}
                onChange={(e) => setPasswordForm({ ...passwordForm, current_password: e.target.value })}
                required
              />
            </div>
            <div className="form-group">
              <label>New Password</label>
              <input
                type="password"
                value={passwordForm.new_password}
                onChange={(e) => setPasswordForm({ ...passwordForm, new_password: e.target.value })}
                required
              />
            </div>
            <div className="form-group">
              <label>Confirm New Password</label>
              <input
                type="password"
                value={passwordForm.confirm_password}
                onChange={(e) => setPasswordForm({ ...passwordForm, confirm_password: e.target.value })}
                required
              />
            </div>
            <button type="submit" className="btn btn-primary">
              <Save size={16} />
              Change Password
            </button>
          </form>
        </div>
      </div>

      {/* Sync Schedule Configuration */}
      <div className="table-container" style={{ marginBottom: '20px' }}>
        <div className="table-header">
          <h3>
            <Clock size={20} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
            Sync Schedule
          </h3>
        </div>
        <div style={{ padding: '20px' }}>
          <p style={{ marginBottom: '15px', color: '#6b7280' }}>
            Current schedule is configured in the server. Syncs run automatically:
          </p>
          <ul style={{ marginLeft: '20px', color: '#374151' }}>
            <li>Provider sync: Every 6 hours</li>
            <li>EPG sync: Every 12 hours</li>
            <li>Health checks: Every 5 minutes</li>
          </ul>
          <p style={{ marginTop: '15px', padding: '15px', background: '#f3f4f6', borderRadius: '6px' }}>
            <strong>Note:</strong> To modify sync schedules, update the server configuration in
            <code style={{ background: '#e5e7eb', padding: '2px 6px', borderRadius: '3px', margin: '0 4px' }}>
              /opt/iptv-middleware/server/services/scheduler.js
            </code>
          </p>
        </div>
      </div>

      {/* System Logs Viewer */}
      <div className="table-container">
        <div className="table-header">
          <h3>
            <FileText size={20} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
            System Logs
          </h3>
          <button className="btn btn-secondary" onClick={loadLogs} disabled={loading}>
            {loading ? 'Loading...' : 'Refresh Logs'}
          </button>
        </div>
        <div style={{ padding: '20px' }}>
          <pre style={{
            background: '#1f2937',
            color: '#f3f4f6',
            padding: '15px',
            borderRadius: '6px',
            maxHeight: '400px',
            overflow: 'auto',
            fontSize: '12px',
            fontFamily: 'monospace',
            whiteSpace: 'pre-wrap',
            wordWrap: 'break-word'
          }}>
            {logs || 'Click "Refresh Logs" to view system logs'}
          </pre>
        </div>
      </div>
    </div>
  );
}

export default Settings;
